import { DatePipe } from '@angular/common';
import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class CommonService {
  private datePipe = new DatePipe('en-IN');
  private dateFormat = 'yyyy-MM-dd';
  private dateLocale = 'en-IN'
  constructor() { }

  MutateArray(OriginalArray) {
    if (null == OriginalArray || "object" != typeof OriginalArray) return OriginalArray;
    var copy = OriginalArray.constructor();
    for (var attr in OriginalArray) {
      if (OriginalArray.hasOwnProperty(attr)) copy[attr] = OriginalArray[attr];
    }
    return copy;
  }

  parseDate(dateString: Date, expectedDateFormat?: string): string {
    // methods required :=> transform(value: any, format?: string, timezone?: string, locale?: string): string | null;
    expectedDateFormat ? this.dateFormat = expectedDateFormat : this.dateFormat;
    return this.datePipe.transform(dateString, this.dateFormat, null, this.dateLocale)
  }

  // parse date from "dd-MM-yyyy HH:mm:SS" to yyyy-dd-MM
  convertDate(dateString) {
    if (!dateString) {
      return null;
    }
    var matchedDate = dateString.match(/^(\d{1,2})-(\d{1,2})-(\d{4}) (\d{1,2}):(\d{1,2}):(\d{1,2})$/);
    return (matchedDate) ? new Date(matchedDate[3], matchedDate[2] - 1, matchedDate[1], matchedDate[4], matchedDate[5], matchedDate[6]) : null;
  }

  findValuesOfYearMonthAndDays(fromDate, toDate) {
    var startDate = new Date(new Date(fromDate).toISOString().substr(0, 10));
    if (!toDate) {
      toDate = new Date().toISOString().substr(0, 10); // need date in YYYY-MM-DD format
    }
    var endDate = new Date(toDate);
    if (startDate > endDate) {
      var swap = startDate;
      startDate = endDate;
      endDate = swap;
    }
    var startYear = startDate.getFullYear();
    // check here leap year
    var february = (startYear % 4 === 0 && startYear % 100 !== 0) || startYear % 400 === 0 ? 29 : 28;
    var daysInMonth = [31, february, 31, 30, 31, 30, 31, 31, 30, 31, 30, 31];

    var yearsDifference = endDate.getFullYear() - startYear;
    var monthDifference = endDate.getMonth() - startDate.getMonth();
    if (monthDifference < 0) {
      yearsDifference--;
      monthDifference += 12;
    }
    var dayDifference = endDate.getDate() - startDate.getDate();
    if (dayDifference < 0) {
      if (monthDifference > 0) {
        monthDifference--;
      } else {
        yearsDifference--;
        monthDifference = 11;
      }
      dayDifference += daysInMonth[startDate.getMonth()];
    }
    return { years: yearsDifference, months: monthDifference, days: dayDifference }
  }

  checkEveryPropertiesNullOrUndefined(obj) {
    for (var key in obj) {
      if (obj[key] !== null && obj[key] != undefined)
        return false;
    }
    return true;
  }

  convertFirstLetterInUpperCase = (amtInWords: string) => {
    amtInWords === undefined ? '' : amtInWords;
    if (amtInWords.toLowerCase() == 'zero' || amtInWords.toLowerCase() == 'one') {
      return amtInWords + ' Rupee Only'
    }
    return amtInWords
      .toLowerCase()
      .split(' ')
      .map(word => word.charAt(0).toUpperCase() + word.slice(1))
      .join(' ') + 'Rupees Only';
  };

  findDaysBetweenTwoDate(fromDate, toDate) {
    const oneDayInMS = 24 * 60 * 60 * 1000; // hours*minutes*seconds*milliseconds
    const lastDate = new Date(toDate).valueOf();
    const firstDate = new Date(fromDate).valueOf();
    const calculatedDays = Math.round(Math.abs((lastDate - firstDate) / oneDayInMS));
    return calculatedDays;
  }

  getUniqueListBy(arrayList, key) {
    return [...new Map(arrayList.map(item => [item[key], item])).values()]
  }
}
